import LandingTitle from '../LandingTitle/LandingTitle';

const SectionTitle = () => {
  return <LandingTitle title="독자들의 성장을 이끈 문장" />;
};

export default SectionTitle;
